export default "__VITE_ASSET__C3WnOtzZ__"